import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { css } from '../../Util';
export function HeaderTitle(props) {
    var _a = props.ariaLevel, ariaLevel = _a === void 0 ? 1 : _a;
    var titleSizeClass = undefined;
    switch (props.titleSize) {
        case 1 /* Large */:
            titleSizeClass = "title-m l";
            break;
        case 2 /* Small */:
            titleSizeClass = "title-xs s";
            break;
        case 0 /* Medium */:
        default:
            titleSizeClass = "body-xl m";
    }
    return (React.createElement("div", { "aria-level": ariaLevel, className: css(props.className, "bolt-header-title", titleSizeClass), role: "heading" }, props.children));
}
